import * as React from 'react';

import { TableRow } from '../components/ui/table.js';
import { cn } from '../lib/utils.js';

export function DimeTableRow({
  className,
  striped = false,
  ...props
}: Readonly<
  React.ComponentProps<typeof TableRow> & {
    // A plain class, so hover and selected backgrounds win on specificity, not source order.
    striped?: boolean;
  }
>) {
  return (
    <TableRow
      className={cn('aria-expanded:bg-muted/50', striped && 'bg-muted/40', className)}
      {...props}
    />
  );
}
